var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasValidTypeAndContent)?_c(_vm.type,{tag:"component",attrs:{"content":_vm.content.content}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }